import { supabase } from '@/integrations/supabase/client';

export interface ClienteComentario {
  id: string;
  tenant_id: number;
  cliente_id: number;
  card_id: string | null;
  autor_id: string;
  conteudo: string;
  created_at: string;
  updated_at: string;
  autor?: {
    first_name: string | null;
    last_name: string | null;
    email: string | null;
  } | null;
}

export interface CreateClienteComentarioInput {
  tenantId: number;
  clienteId: string;
  cardId?: string;
  autorId: string;
  conteudo: string;
}

function formatAutorNome(autor?: ClienteComentario['autor']): string {
  if (!autor) return 'Usuário';
  const nome = [autor.first_name, autor.last_name].filter(Boolean).join(' ').trim();
  return nome || autor.email || 'Usuário';
}

export { formatAutorNome };

export async function listClienteComentarios(
  clienteId: string,
  tenantId: number
): Promise<ClienteComentario[]> {
  const { data, error } = await supabase
    .from('cliente_comentarios')
    .select(
      `
      id,
      tenant_id,
      cliente_id,
      card_id,
      autor_id,
      conteudo,
      created_at,
      updated_at,
      autor:profiles!cliente_comentarios_autor_id_fkey(first_name, last_name, email)
    `
    )
    .eq('cliente_id', clienteId)
    .eq('tenant_id', tenantId)
    .order('created_at', { ascending: false })
    .limit(50);

  if (error) {
    throw new Error(`Erro ao carregar comentários: ${error.message}`);
  }

  return (data || []) as ClienteComentario[];
}

export async function createClienteComentario(
  input: CreateClienteComentarioInput
): Promise<ClienteComentario> {
  const conteudo = input.conteudo.trim();
  if (!conteudo) {
    throw new Error('Digite um comentário antes de salvar');
  }

  const { data, error } = await supabase
    .from('cliente_comentarios')
    .insert({
      tenant_id: input.tenantId,
      cliente_id: Number(input.clienteId),
      card_id: input.cardId ?? null,
      autor_id: input.autorId,
      conteudo,
    })
    .select(
      `
      id,
      tenant_id,
      cliente_id,
      card_id,
      autor_id,
      conteudo,
      created_at,
      updated_at,
      autor:profiles!cliente_comentarios_autor_id_fkey(first_name, last_name, email)
    `
    )
    .single();

  if (error) {
    throw new Error(`Erro ao salvar comentário: ${error.message}`);
  }

  return data as ClienteComentario;
}
